// @ts-nocheck
/**
 * @function SwalToast
 * @description Displays a toast using the Snackbar component from the Material-UI library.
 * Prevents duplicate toasts with the same ID and adds validation for safe usage.
 * @param {object} props - The props object.
 * @param {string} [props.icon='success'] - The type of the toast icon. Defaults to 'success'.
 * @param {string} props.title - The title of the toast.
 * @param {string} [props.id] - The unique ID of the toast to prevent duplication.
 * @param {number} [props.autoHideDuration=180000] - The duration before the toast hides automatically.
 * @returns {void}
 */
const swalToast = (() => {
  // Track active toast IDs to prevent duplicates
  const activeToasts = new Set();

  return ({
    icon = 'success',
    title,
    anchorOrigin = {
      vertical: 'bottom',
      horizontal: 'right',
    },
    id,
    autoHideDuration = 5000,
    persist = false,
  }) => {
    // Validate icon type
    const validIcons = ['success', 'error', 'info', 'warning', 'report'];
    const toastType = validIcons.includes(icon) ? icon : 'info';

    // Prevent duplicate toasts if `id` is provided
    if (id && activeToasts.has(id)) {
      return;
    }

    // Add the ID to the active toasts set
    if (id) {
      activeToasts.add(id);
    }

    window.enqueueSnackbar(title, {
      variant: toastType,
      preventDuplicate: true,
      ...(!persist ? { autoHideDuration } : {}), // if persist true don't add autohideduration
      anchorOrigin,
      persist,
      onClose: () => {
        // Remove the ID from the active toasts set on close
        if (id) {
          activeToasts.delete(id);
        }
      },
    });

    // Update the live region for screen readers
    const liveRegion = document.getElementById('snackbar-live-region');
    if (liveRegion) {
      // Clear the live region first (to ensure re-announcement)
      liveRegion.textContent = '';
      setTimeout(() => {
        liveRegion.textContent = title;
      }, 100); // Small delay to ensure content is read
    }
  };
})();
export default swalToast;
